export const getFilteredContacts = (setApp, history, filterObj) => {
  setApp((oldApp) => ({
    ...oldApp,
    getMetricesQuery: filterObj,
    paginationOffset: 1,
  }));
  history.push('/customers');
};

export const getFilteredSuperadminContacts = (setApp, history, filterObj) => {
  setApp((oldApp) => ({
    ...oldApp,
    getSuMetricesQuery: filterObj,
    paginationOffset: 1,
  }));
  history.push('/superAdminCustomers');
};

export const SEARCH_TYPES = {
  Clear: 'Clear',
  MetricesContacts: 'MetricesContacts',
  RefContacts: 'RefContacts',
  AllContacts: 'AllContacts',
  TagsFiltered: 'TagsFiltered'
};
